exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indented[data-v-5948ee38]{margin:20px;max-width:550px}.spacer[data-v-5948ee38]{height:15px;border:0 solid #000}.spaced[data-v-5948ee38]{margin-top:10px}.button[data-v-5948ee38]{border:1px solid gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5948ee38","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_DeleteCategory.vue
// module id = 167
// module chunks = 0